import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_665214ce-6ff3-44fe-8494-ab0b47b80e74/artifacts/nggtror1_logo.png";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-steel-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="NJ Steel Fabrications"
                className="h-12 w-auto brightness-0 invert" />

              <div>
                <p className="font-heading font-bold text-xl tracking-tight uppercase">
                  NJ Steel
                </p>
                <p className="font-body text-xs text-slate-400 -mt-1">
                  Fabrications
                </p>
              </div>
            </Link>
            <p className="font-body text-slate-400 text-sm leading-relaxed">
              Melbourne's Premier Steel Fabrication Experts. Quality steel solutions for residential, commercial, and industrial projects.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-bold text-lg uppercase tracking-wide mb-6">
              Quick Links
            </h3>
            <nav className="flex flex-col gap-3">
              <Link
                to="/"
                data-testid="footer-link-home"
                className="font-body text-slate-400 hover:text-white transition-colors text-sm">

                Home
              </Link>
              <Link
                to="/services"
                data-testid="footer-link-services"
                className="font-body text-slate-400 hover:text-white transition-colors text-sm">

                Our Services
              </Link>
              <Link
                to="/contact"
                data-testid="footer-link-contact"
                className="font-body text-slate-400 hover:text-white transition-colors text-sm">

                Contact Us
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-bold text-lg uppercase tracking-wide mb-6">
              Contact Us
            </h3>
            <div className="flex flex-col gap-4">
              <a
                href="tel:0424456596"
                data-testid="footer-phone"
                className="flex items-center gap-3 font-body text-slate-400 hover:text-white transition-colors text-sm">

                <Phone size={18} className="text-primary" />
                0424 456 596
              </a>
              <a
                href="mailto:njsteelfab@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-3 font-body text-slate-400 hover:text-white transition-colors text-sm">

                <Mail size={18} className="text-primary" />
                njsteelfab@gmail.com
              </a>
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-primary flex-shrink-0 mt-0.5" />
                <p className="font-body text-slate-400 text-sm">
                  5/17-19 Somerton Park Drive,<br />
                  Campbellfield VIC 3061,<br />
                  Victoria, Australia
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-body text-slate-500 text-sm">
              © {new Date().getFullYear()} NJ Steel Fabrications. All rights reserved.
            </p>
            <p className="font-body !font-semibold !text-sm !text-[#FFFFFF]">ABN: 18 618 613 004

            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;